module.exports = __webpack_public_path__ + "static/img/guide-betting-history.b5c40e8.png";